import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(3.2496 1.2504)",
		d: "M7.25 0C11.2541 0 14.5 3.24594 14.5 7.25C14.5 9.71886 13.2648 11.8978 11.3799 13.207L15.8057 20.875L14.5068 21.625L10.0664 13.9326C9.20053 14.298 8.24886 14.5 7.25 14.5C3.24594 14.5 0 11.2541 0 7.25C0 3.24594 3.24594 0 7.25 0ZM7.25 1.5C4.07436 1.5 1.5 4.07436 1.5 7.25C1.5 10.4256 4.07436 13 7.25 13C10.4256 13 13 10.4256 13 7.25C13 4.07436 10.4256 1.5 7.25 1.5Z",
		fill: "currentColor"
	})
});
export default SvgSearchIcon;
